export interface EmojiCategory {
  id: string
  name: string
  icon: string
  emojis: string[]
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    id: "frequent",
    name: "Frequently Used",
    icon: "🕐",
    emojis: [
      "👍", "❤️", "😂", "🔥", "🎉", "😍", "🙏", "😭", "🥺", "✨",
      "💯", "🤣", "😊", "🥰", "😎", "💀", "🤔", "👀", "💪", "🫡",
    ],
  },
  {
    id: "smileys",
    name: "Smileys & People",
    icon: "😀",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "😊",
      "😇", "🥰", "😍", "🤩", "😘", "😗", "😚", "😙", "🥲", "😋",
      "😛", "😜", "🤪", "😝", "🤑", "🤗", "🤭", "🫢", "🫣", "🤫",
      "🤔", "🫡", "🤐", "🤨", "😐", "😑", "😶", "🫥", "😏", "😒",
      "🙄", "😬", "🤥", "😌", "😔", "😪", "🤤", "😴", "😷", "🤒",
      "🤕", "🤢", "🤮", "🥵", "🥶", "🥴", "😵", "🤯", "🤠", "🥳",
      "🥸", "😎", "🤓", "🧐", "😕", "🫤", "😟", "🙁", "😮", "😯",
      "😲", "😳", "🥺", "🥹", "😦", "😧", "😨", "😰", "😥", "😢",
      "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫", "🥱", "😤",
      "😡", "😠", "🤬", "😈", "👿", "💀", "☠️", "💩", "🤡", "👹",
      "👺", "👻", "👽", "👾", "🤖", "😺", "😸", "😹", "😻", "😼",
      "😽", "🙀", "😿", "😾",
    ],
  },
  {
    id: "gestures",
    name: "Gestures & Body",
    icon: "👋",
    emojis: [
      "👋", "🤚", "🖐️", "✋", "🖖", "🫱", "🫲", "🫳", "🫴", "🫷",
      "🫸", "👌", "🤌", "🤏", "✌️", "🤞", "🫰", "🤟", "🤘", "🤙",
      "👈", "👉", "👆", "🖕", "👇", "☝️", "🫵", "👍", "👎", "✊",
      "👊", "🤛", "🤜", "👏", "🙌", "🫶", "👐", "🤲", "🤝", "🙏",
      "✍️", "💅", "🤳", "💪", "🦾", "🦿", "🦵", "🦶", "👂", "🦻",
      "👃", "🧠", "🫀", "🫁", "🦷", "🦴", "👀", "👁️", "👅", "👄",
    ],
  },
  {
    id: "hearts",
    name: "Hearts & Symbols",
    icon: "❤️",
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
      "❤️‍🔥", "❤️‍🩹", "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝",
      "💟", "♥️", "💋", "💌", "💐", "🌹", "✨", "⭐", "🌟", "💫",
      "🔥", "💥", "💢", "💦", "💨", "🕊️", "🎵", "🎶", "🔔", "📣",
      "💬", "💭", "🗯️", "♠️", "♣️", "♥️", "♦️", "🃏", "🎴", "🀄",
      "⚡", "☀️", "🌈", "🎯", "💎", "👑", "🏆", "🥇", "🥈", "🥉",
      "🏅", "🎖️", "✅", "❌", "⭕", "❗", "❓", "‼️", "⁉️", "💯",
    ],
  },
  {
    id: "animals",
    name: "Animals & Nature",
    icon: "🐶",
    emojis: [
      "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐻‍❄️", "🐨",
      "🐯", "🦁", "🐮", "🐷", "🐸", "🐵", "🙈", "🙉", "🙊", "🐒",
      "🐔", "🐧", "🐦", "🐤", "🐣", "🐥", "🦆", "🦅", "🦉", "🦇",
      "🐺", "🐗", "🐴", "🦄", "🐝", "🪱", "🐛", "🦋", "🐌", "🐞",
      "🐜", "🪲", "🦗", "🕷️", "🦂", "🐢", "🐍", "🦎", "🦖", "🦕",
      "🐙", "🦑", "🦐", "🦞", "🦀", "🐡", "🐠", "🐟", "🐬", "🐳",
      "🐋", "🦈", "🐊", "🐅", "🐆", "🦓", "🦍", "🦧", "🐘", "🦛",
      "🦏", "🐪", "🐫", "🦒", "🦘", "🦬", "🐃", "🐂", "🐄", "🐎",
      "🌵", "🎄", "🌲", "🌳", "🌴", "🪵", "🌱", "🌿", "☘️", "🍀",
      "🍁", "🍂", "🍃", "🪻", "🌺", "🌻", "🌼", "🌷", "🌹", "🥀",
    ],
  },
  {
    id: "food",
    name: "Food & Drink",
    icon: "🍔",
    emojis: [
      "🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈",
      "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🥦",
      "🥬", "🥒", "🌶️", "🫑", "🌽", "🥕", "🫒", "🧄", "🧅", "🥔",
      "🍠", "🫘", "🥜", "🌰", "🍞", "🥐", "🥖", "🫓", "🥨", "🥯",
      "🥞", "🧇", "🧀", "🍖", "🍗", "🥩", "🥓", "🍔", "🍟", "🍕",
      "🌭", "🥪", "🌮", "🌯", "🫔", "🥙", "🧆", "🥚", "🍳", "🥘",
      "🍲", "🫕", "🥣", "🥗", "🍿", "🧈", "🧂", "🥫", "🍱", "🍘",
      "🍙", "🍚", "🍛", "🍜", "🍝", "🍣", "🍤", "🍩", "🍪", "🎂",
      "🍰", "🧁", "🥧", "🍫", "🍬", "🍭", "🍮", "🍯", "🍼", "🥛",
      "☕", "🫖", "🍵", "🍶", "🍾", "🍷", "🍸", "🍹", "🍺", "🍻",
    ],
  },
  {
    id: "activities",
    name: "Activities",
    icon: "⚽",
    emojis: [
      "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱",
      "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳",
      "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷",
      "⛸️", "🥌", "🎿", "⛷️", "🏂", "🏋️", "🤸", "🤺", "🏄", "🚣",
      "🧗", "🚴", "🚵", "🎪", "🎭", "🎨", "🎬", "🎤", "🎧", "🎼",
      "🎹", "🥁", "🪘", "🎷", "🎺", "🪗", "🎸", "🎻", "🎲", "♟️",
      "🎯", "🎳", "🎮", "🕹️", "🎰", "🧩",
    ],
  },
  {
    id: "objects",
    name: "Objects",
    icon: "💡",
    emojis: [
      "📱", "💻", "⌨️", "🖥️", "🖨️", "🖱️", "🖲️", "💾", "💿", "📀",
      "🎥", "📸", "📷", "📹", "📼", "🔍", "🔎", "🕯️", "💡", "🔦",
      "📔", "📕", "📖", "📗", "📘", "📙", "📚", "📓", "📒", "📃",
      "📜", "📄", "📰", "🗞️", "📑", "🔖", "🏷️", "💰", "🪙", "💴",
      "💵", "💶", "💷", "💸", "💳", "🧾", "💹", "✉️", "📧", "📨",
      "📩", "📤", "📥", "📦", "📫", "📪", "📬", "📭", "📮", "🗳️",
      "✏️", "✒️", "🖋️", "🖊️", "🖌️", "🖍️", "📝", "📁", "📂", "🗂️",
      "📅", "📆", "📇", "📈", "📉", "📊", "📋", "📌", "📍", "📎",
      "🖇️", "📏", "📐", "✂️", "🗃️", "🗄️", "🗑️", "🔒", "🔓", "🔑",
      "🗝️", "🔨", "🪓", "⛏️", "🛠️", "🗡️", "⚔️", "🔫", "🪃", "🏹",
    ],
  },
  {
    id: "flags",
    name: "Flags",
    icon: "🏁",
    emojis: [
      "🏁", "🚩", "🎌", "🏴", "🏳️", "🏳️‍🌈", "🏳️‍⚧️", "🏴‍☠️",
      "🇺🇸", "🇬🇧", "🇫🇷", "🇩🇪", "🇮🇹", "🇪🇸", "🇵🇹", "🇧🇷",
      "🇲🇽", "🇨🇦", "🇦🇺", "🇯🇵", "🇰🇷", "🇨🇳", "🇮🇳", "🇷🇺",
      "🇿🇦", "🇳🇬", "🇪🇬", "🇰🇪", "🇦🇷", "🇨🇴", "🇨🇱", "🇵🇪",
      "🇻🇪", "🇨🇺", "🇵🇷", "🇯🇲", "🇩🇴", "🇭🇹", "🇹🇹", "🇧🇸",
      "🇵🇭", "🇹🇭", "🇻🇳", "🇮🇩", "🇲🇾", "🇸🇬", "🇵🇰", "🇧🇩",
      "🇹🇷", "🇸🇦", "🇦🇪", "🇮🇱", "🇮🇶", "🇮🇷", "🇳🇱", "🇧🇪",
      "🇨🇭", "🇦🇹", "🇸🇪", "🇳🇴", "🇩🇰", "🇫🇮", "🇵🇱", "🇺🇦",
    ],
  },
]

export const EMOJI_KEYWORDS: Record<string, string> = {
  "👍": "thumbs up like yes good approve ok",
  "👎": "thumbs down dislike no bad disapprove",
  "❤️": "red heart love like",
  "😂": "laugh crying tears joy funny lol lmao",
  "🔥": "fire hot lit flame",
  "🎉": "party tada celebration congrats",
  "😍": "heart eyes love crush",
  "🙏": "pray please thank you thanks hope wish",
  "😭": "crying sob sad tears",
  "🥺": "pleading puppy eyes cute please",
  "✨": "sparkles magic stars shine",
  "💯": "hundred perfect score",
  "🤣": "rofl rolling floor laughing",
  "😊": "smile happy blush",
  "🥰": "love hearts face smiling",
  "😎": "cool sunglasses",
  "💀": "skull dead dying ded",
  "🤔": "thinking hmm pondering",
  "👀": "eyes look see watching",
  "💪": "muscle strong flex arm bicep",
  "🫡": "salute respect",
  "😀": "grinning smile happy",
  "😃": "smiley happy grinning",
  "😄": "grin smile happy",
  "😁": "beaming grin happy",
  "😆": "laughing squint haha",
  "😅": "sweat nervous laugh awkward",
  "🙂": "slight smile",
  "😇": "angel halo innocent",
  "🤩": "star struck excited amazed",
  "😘": "kiss blow love",
  "😗": "kiss",
  "😚": "kiss closed eyes",
  "😙": "kiss smiling eyes",
  "🥲": "smile tear sad happy",
  "😋": "yummy delicious food tongue",
  "😛": "tongue out playful",
  "😜": "wink tongue crazy",
  "🤪": "zany crazy wild",
  "😝": "tongue squint silly",
  "🤑": "money face rich dollar",
  "🤗": "hug hugging warm",
  "🤭": "giggle tee hee oops",
  "🫢": "oops surprised hand",
  "🫣": "peeking shy hiding",
  "🤫": "shush quiet secret",
  "🤐": "zipper mouth shut",
  "🤨": "raised eyebrow skeptical",
  "😐": "neutral face blank",
  "😑": "expressionless blank",
  "😶": "no mouth silence",
  "🫥": "dotted face disappear",
  "😏": "smirk suggestive sly",
  "😒": "unamused annoyed",
  "🙄": "eye roll whatever",
  "😬": "grimace awkward cringe",
  "🤥": "lying pinocchio",
  "😌": "relieved calm peace",
  "😔": "pensive sad down",
  "😪": "sleepy tired",
  "🤤": "drooling yummy",
  "😴": "sleeping zzz tired",
  "😷": "mask sick covid",
  "🤒": "thermometer sick fever",
  "🤕": "bandage hurt injured",
  "🤢": "nauseous sick green",
  "🤮": "vomit sick throw up",
  "🥵": "hot sweating heat",
  "🥶": "cold freezing frozen",
  "🥴": "woozy drunk dizzy",
  "😵": "dizzy spiral knocked out",
  "🤯": "mind blown exploding head",
  "🤠": "cowboy hat yeehaw",
  "🥳": "party celebrate birthday",
  "🥸": "disguise incognito glasses",
  "🤓": "nerd glasses smart",
  "🧐": "monocle inspect classy",
  "😕": "confused unsure",
  "🫤": "diagonal mouth meh",
  "😟": "worried concerned",
  "🙁": "frowning sad unhappy",
  "😮": "open mouth surprised oh",
  "😯": "hushed surprised",
  "😲": "astonished shocked wow",
  "😳": "flushed embarrassed surprised",
  "🥹": "holding back tears touched emotional",
  "😨": "fearful afraid scared",
  "😰": "anxious sweat worried",
  "😥": "sad relieved disappointed",
  "😢": "cry sad tear",
  "😱": "scream fear horror",
  "😤": "huff triumph steam nose",
  "😡": "angry mad rage pouting",
  "😠": "angry mad",
  "🤬": "cursing swearing angry symbols",
  "😈": "devil horns smiling evil",
  "👿": "imp angry devil",
  "💩": "poop poo crap",
  "🤡": "clown silly funny",
  "👻": "ghost boo spooky halloween",
  "👽": "alien ufo extraterrestrial",
  "👾": "space invader monster game",
  "🤖": "robot bot ai",
  "👋": "wave hello hi bye",
  "🤚": "raised back hand stop",
  "🖐️": "hand fingers spread",
  "✋": "raised hand stop high five",
  "🖖": "vulcan spock star trek",
  "👌": "ok perfect nice fine",
  "🤌": "pinched fingers italian",
  "🤏": "pinching small tiny little",
  "✌️": "peace victory two",
  "🤞": "fingers crossed luck hope",
  "🫰": "hand snap money tip",
  "🤟": "love you gesture rock",
  "🤘": "rock on metal horns",
  "🤙": "call me shaka hang loose",
  "👈": "point left",
  "👉": "point right",
  "👆": "point up",
  "👇": "point down",
  "☝️": "point up index finger",
  "🫵": "point at you",
  "✊": "fist raised power",
  "👊": "fist bump punch",
  "🤛": "left fist bump",
  "🤜": "right fist bump",
  "👏": "clap applause bravo",
  "🙌": "hands raised celebration hooray",
  "🫶": "heart hands love",
  "👐": "open hands jazz",
  "🤲": "palms up together please",
  "🤝": "handshake deal agreement",
  "💅": "nail polish slay queen",
  "🧡": "orange heart",
  "💛": "yellow heart",
  "💚": "green heart",
  "💙": "blue heart",
  "💜": "purple heart",
  "🖤": "black heart",
  "🤍": "white heart",
  "🤎": "brown heart",
  "💔": "broken heart heartbreak",
  "❤️‍🔥": "heart on fire passion burning love",
  "❤️‍🩹": "mending heart healing recovery",
  "💕": "two hearts love",
  "💞": "revolving hearts love",
  "💓": "beating heart love pulse",
  "💗": "growing heart love",
  "💖": "sparkling heart love",
  "💘": "heart arrow cupid love",
  "💝": "heart ribbon gift love",
  "🌹": "rose flower love romance",
  "⭐": "star",
  "🌟": "glowing star sparkle",
  "💫": "dizzy star shooting",
  "💥": "collision boom bang",
  "💢": "anger symbol mad",
  "🎵": "music note song",
  "🎶": "music notes song",
  "🔔": "bell notification alert",
  "💎": "gem diamond jewel",
  "👑": "crown king queen royal",
  "🏆": "trophy winner champion",
  "🥇": "gold medal first place",
  "✅": "check mark done complete yes",
  "❌": "cross mark no wrong",
  "🐶": "dog puppy",
  "🐱": "cat kitty",
  "🐭": "mouse",
  "🐰": "bunny rabbit",
  "🦊": "fox",
  "🐻": "bear",
  "🐼": "panda",
  "🐯": "tiger",
  "🦁": "lion",
  "🐮": "cow",
  "🐷": "pig",
  "🐸": "frog",
  "🐵": "monkey",
  "🙈": "see no evil monkey",
  "🙉": "hear no evil monkey",
  "🙊": "speak no evil monkey",
  "🦄": "unicorn magic",
  "🐍": "snake",
  "🐬": "dolphin",
  "🐳": "whale",
  "🦈": "shark",
  "🐘": "elephant",
  "🍎": "apple red fruit",
  "🍕": "pizza food",
  "🍔": "hamburger burger food",
  "🍟": "fries french fries food",
  "🌮": "taco food mexican",
  "🍣": "sushi food japanese",
  "🍩": "donut doughnut food",
  "🍪": "cookie food",
  "🎂": "birthday cake food celebration",
  "🍰": "cake food dessert",
  "☕": "coffee hot drink",
  "🍺": "beer drink alcohol",
  "🍷": "wine drink alcohol",
  "⚽": "soccer football",
  "🏀": "basketball",
  "🏈": "football american",
  "⚾": "baseball",
  "🎾": "tennis",
  "🎮": "video game controller gaming",
  "🎲": "dice game",
  "🎯": "bullseye target direct hit",
  "📱": "phone mobile cell",
  "💻": "laptop computer",
  "💡": "light bulb idea",
  "📸": "camera photo picture",
  "💰": "money bag rich",
  "💵": "dollar money cash bill",
  "💸": "money wings flying cash",
  "📈": "chart up graph increase",
  "📉": "chart down graph decrease",
  "🔑": "key password unlock",
  "🔒": "lock secure locked",
  "🔓": "unlock open",
  "🚀": "rocket launch ship space",
  "✈️": "airplane plane travel fly",
  "🏠": "house home",
  "🏁": "checkered flag finish race",
  "🚩": "red flag warning triangular",
  "🇺🇸": "usa america united states flag",
  "🇬🇧": "uk britain england flag",
  "🇫🇷": "france french flag",
  "🇩🇪": "germany german flag",
  "🇯🇵": "japan japanese flag",
  "🇧🇷": "brazil brazilian flag",
  "🇲🇽": "mexico mexican flag",
  "🇨🇦": "canada canadian flag",
  "🇦🇺": "australia australian flag",
  "🇮🇳": "india indian flag",
}

export function searchEmojis(query: string): string[] {
  if (!query.trim()) return []
  const lower = query.toLowerCase()
  const results: string[] = []

  for (const [emoji, keywords] of Object.entries(EMOJI_KEYWORDS)) {
    if (keywords.includes(lower)) {
      results.push(emoji)
    }
  }

  // Also search through all categories for emojis not in EMOJI_KEYWORDS
  if (results.length < 10) {
    for (const category of EMOJI_CATEGORIES) {
      if (category.name.toLowerCase().includes(lower)) {
        for (const emoji of category.emojis) {
          if (!results.includes(emoji)) {
            results.push(emoji)
          }
        }
      }
    }
  }

  return results.slice(0, 50)
}
